import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface IAuthorityGuardProps {
  /** URAM codes the route declares; any one of them grants access (rnav semantics). */
  authority: string[];
  /** URAM codes the user holds; the standalone host fills them from /v1/me. */
  granted: readonly string[];
  children: ReactNode;
}

/** Route-level guard owned by the host, fail closed like rnav's AuthorityGuard. */
export function AuthorityGuard({ authority, granted, children }: IAuthorityGuardProps) {
  const { t } = useTranslation();
  const allowed = authority.length === 0 || authority.some((code) => granted.includes(code));
  if (!allowed) {
    return <p role="alert">{t('noAccess')}</p>;
  }
  return children;
}
